import './css/styles.scss';

const DEFAULT_ROTATE_MS = 4300; // ~2.5s

function HolySpiritActivate() {
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  // spåra senaste input-metod
  let lastInput: 'pointer' | 'keyboard' = 'pointer';
  window.addEventListener('pointerdown', () => { lastInput = 'pointer'; }, { passive: true });
  window.addEventListener('keydown',     () => { lastInput = 'keyboard'; });

  document.querySelectorAll<HTMLElement>('.feature-swap').forEach(root => {
    const tabs     = Array.from(root.querySelectorAll<HTMLElement>('.feature-swap__tab'));
    const imgs     = Array.from(root.querySelectorAll<HTMLElement>('.feature-swap__img'));
    const imgTexts = Array.from(root.querySelectorAll<HTMLElement>('.feature-swap__img-text'));
    if (!tabs.length) return;

    const intervalMs = Number((root as HTMLElement).dataset.interval) || DEFAULT_ROTATE_MS;

    let index = 0;
    let timer: number | null = null;
    let inView = false;
    let hovered = false;        // endast för TAB-hover, inte hela blocket
    let focusedInside = false;  // pausas bara vid keyboard-fokus

    const setActive = (i: number) => {
      const total = tabs.length;
      index = ((i % total) + total) % total;

      tabs.forEach((t, k) => {
        const on = k === index;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('clicked-on', on);
      });

      imgs.forEach((el, k) => {
        el.classList.toggle('opacity-100', k === index);
        el.classList.toggle('opacity-0',   k !== index);

      });

      imgTexts.forEach((el, k) => {
        el.classList.toggle('opacity-100', k === index);
        el.classList.toggle('opacity-0',   k !== index);
      });
    };

    const next  = () => setActive(index + 1);
    const stop  = () => { if (timer != null) { window.clearInterval(timer); timer = null; } };
    const start = () => {
      if (reduceMotion || !inView || hovered || focusedInside || document.hidden || tabs.length < 2) return;
      stop();
      timer = window.setInterval(next, intervalMs);
    };

    // init
    setActive(0);

    // TAB-interaktion: pausa bara när man hovrar över själva tabben
    tabs.forEach((t, i) => {
      t.addEventListener('mouseenter', () => { hovered = true; stop(); });
      t.addEventListener('mouseleave', () => { hovered = false; start(); });
      t.addEventListener('click', (e) => {
        setActive(i);
        // fortsätt autokörning direkt efter klick
        (e.currentTarget as HTMLElement).blur(); // släpp fokus
        focusedInside = false;
        hovered = false;
        start();
      });
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); setActive(i + 1); }
        if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   { e.preventDefault(); setActive(i - 1); }
      });
    });

    // TA BORT paus på hover över hela blocket (detta var orsaken)
    // root.addEventListener('pointerenter', () => { hovered = true;  stop(); });
    // root.addEventListener('pointerleave', () => { hovered = false; start(); });

    // Pausa endast vid keyboard-fokus inne i blocket
    root.addEventListener('focusin',  () => {
      focusedInside = (lastInput === 'keyboard');
      if (focusedInside) stop();
    });
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget as Node)) { focusedInside = false; start(); }
    });

    // flik ej aktiv → pausa
    document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });

    // starta först när blocket syns (≥ 50 %)
    const io = new IntersectionObserver((entries) => {
      inView = !!entries[0].isIntersecting;
      inView ? start() : stop();
    }, { threshold: 0.5 });
    io.observe(root);
  });
}
// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	HolySpiritActivate();
});
